import { render, staticRenderFns } from "./MiniShippingCarComponent.vue?vue&type=template&id=1ad2b1b8"
import script from "./MiniShippingCarComponent.vue?vue&type=script&lang=js"
export * from "./MiniShippingCarComponent.vue?vue&type=script&lang=js"
import style0 from "./MiniShippingCarComponent.vue?vue&type=style&index=0&id=1ad2b1b8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports